<template>
  <div class="vs-spacer"></div>
</template>
<script>
export default {
  name:'VsSpacer'
}
</script>
